<img src="assets/images/logo-smart.png" class="logo" >

<h3 id="title" class="title">{{ 'tytul.logowanie' | translate }}</h3>

<nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
  <p class="alert-title"><b>{{ 'komunikat.blad.logowanie' | translate }}!</b></p>
</nb-alert>

<form (ngSubmit)="login()" #form="ngForm" aria-labelledby="title">

  <div class="form-control-group">
    <label class="label" for="input-username">Login/e-mail:</label>
    <input nbInput
           fullWidth
           [(ngModel)]="user.login"
           #username="ngModel"
           name="username"
           id="input-username"
           placeholder="Login/e-mail"
           fieldSize="large"
           [status]="username.dirty ? (username.invalid  ? 'danger' : 'success') : 'basic'"
           [required]="getConfigValue('forms.validation.login.required')"
           [attr.aria-invalid]="username.invalid && username.touched ? true : null">
    <ng-container *ngIf="username.invalid && username.touched">
      <p class="caption status-danger" *ngIf="username.errors?.required">
        {{ 'komunikat.blad.pole-jest-wymagane' | translate }}!
      </p>
    </ng-container>
  </div>

  <div class="form-control-group">
    <span class="label-with-link">
      <label class="label" for="input-password">{{ 'etykieta.haslo' | translate }}:</label>
      <a *ngIf="env.auth.forgotPassword" class="forgot-password caption-2" routerLink="../request-password">{{ 'etykieta.zapomniales-hasla' | translate }}</a>
    </span>
    <input nbInput
           fullWidth
           [(ngModel)]="user.password"
           #password="ngModel"
           name="password"
           type="password"
           id="input-password"
           placeholder="{{ 'etykieta.haslo' | translate }}"
           fieldSize="large"
           [status]="password.dirty ? (password.invalid  ? 'danger' : 'success') : 'basic'"
           [required]="getConfigValue('forms.validation.password.required')"
           [minlength]="getConfigValue('forms.validation.password.minLength')"
           [attr.aria-invalid]="password.invalid && password.touched ? true : null">
    <ng-container *ngIf="password.invalid && password.touched ">
      <p class="caption status-danger" *ngIf="password.errors?.required">
        {{ 'komunikat.blad.haslo-jest-wymagane' | translate }}!
      </p>
      <p class="caption status-danger" *ngIf="password.errors?.minlength">
        {{ 'komunikat.blad.haslo-dlugosc-poczatek' | translate }} {{ getConfigValue('forms.validation.password.minLength') }} {{ 'komunikat.blad.haslo-dlugosc-koniec' | translate }}
      </p>
    </ng-container>
  </div>

  <button nbButton
          fullWidth
          status="primary"
          size="large"
          [disabled]="submitted || !form.valid"
          [class.btn-pulse]="submitted">
    {{ 'akcja.zaloguj' | translate }}
  </button>
</form>

<section *ngIf="env.auth.register && socialLinks && socialLinks.length > 0" class="links" aria-label="Portale społecznościowe">
  {{ 'etykieta.logowanie-kontem-zewnetrznym' | translate }}:
  <div class="socials">
    <ng-container *ngFor="let socialLink of socialLinks">
      <a *ngIf="socialLink.link"
         [routerLink]="socialLink.link"
         [attr.target]="socialLink.target"
         [attr.class]="socialLink.icon"
         [class.with-icon]="socialLink.icon">
        <nb-icon *ngIf="socialLink.icon; else title" [icon]="socialLink.icon" (click)="socialLogin(socialLink.icon); $event.preventDefault()"></nb-icon>
        <ng-template #title>{{ socialLink.title }}</ng-template>
      </a>
      <a *ngIf="socialLink.url"
         [attr.href]="socialLink.url"
         [attr.target]="socialLink.target"
         [attr.class]="socialLink.icon"
         [class.with-icon]="socialLink.icon">
        <nb-icon *ngIf="socialLink.icon; else title" [icon]="socialLink.icon" (click)="socialLogin(socialLink.icon); $event.preventDefault()"></nb-icon>
        <ng-template #title>{{ socialLink.title }}</ng-template>
      </a>
    </ng-container>
  </div>
</section>

<section *ngIf="env.auth.register" class="another-action" aria-label="Register">
  {{ 'etykieta.nie-masz-konta' | translate }} <a class="text-link" routerLink="../register">{{ 'etykieta.zarejestruj-sie' | translate }}</a>
</section>

<section class="another-action">
  <ngx-wybor-jezyka-panel></ngx-wybor-jezyka-panel>
</section>